import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import './registerServiceWorker';
import * as firebase from 'firebase/app';
import 'firebase/firestore';

Vue.config.productionTip = false;

// Initialize Firebase
const config = {
  apiKey: 'AIzaSyCL8j9mwRd_kMyNugnPPCEItS9_oZm9rBA',
  authDomain: 'ap-lit-hodapp.firebaseapp.com',
  databaseURL: 'https://ap-lit-hodapp.firebaseio.com',
  projectId: 'ap-lit-hodapp',
  storageBucket: 'ap-lit-hodapp.appspot.com',
  messagingSenderId: '910003160579',
};

firebase.initializeApp(config);

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
